export default "__VITE_ASSET__D4lsk27G__"